<template>
  <div ref="popover" @click.stop="" class="popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show">
    <div class="popover-content">
      <fieldset class="form-group mb-0">
        <div class="form-check">
          <label class="form-check-label">
            <input type="radio" class="form-check-input" name="photo_size" value="1" v-model="photoSizeId"><trans-text i18nKey="ui['7'][11]" :isHtml="true" />
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input type="radio" class="form-check-input" name="photo_size" value="2" v-model="photoSizeId"><trans-text i18nKey="ui['7'][12]" :isHtml="true" />
          </label>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import {required,number,numberLength} from 'systems/validators'
  import FormPartialBase from 'extends/FormPartialBase.vue'
  import SchoolCode from 'processor/SchoolCode'

  export default {
    name:"",
    extends:FormPartialBase,
    props:["photoSizeTargetCartPhoto"],
    components: {
    },
    data () {
      return {
        photoSizeId: null,
      }
    },
    watch:{
      "$root.lastWindowClick"(){
        this.$emit("hideCartPhotoSizeChangePopover")
      },
      photoSizeTargetCartPhoto(){
        if(!this.photoSizeTargetCartPhoto){ return }
        if(!this.photoSizeTargetCartPhoto.photo_sizes){ return }
        let photoSize = app.make("_").first(this.photoSizeTargetCartPhoto.photo_sizes)

        if(!photoSize){
          this.photoSizeId = 1
          return
        }
        this.photoSizeId = photoSize.id
      },
      photoSizeId(){
        this.$emit("updateCartPhotoPhotoSize",this.photoSizeTargetCartPhoto,this.photoSizeId)
      }
    },
    mounted(){
    },
    methods:{
    }
  }
</script>

<style>
  .popover-content .size-info{
    border: 1px solid #f79919;
    padding: 0 2px;
    width: 20px;
    display: inline-block;
    text-align: center;
    line-height: 1rem;
    color: #f79919;
  }
</style>

<style lang="scss" scoped>
  .popover-content{
    background-color: #fef7ea;
    &:after{
      background-color: #fef7ea;
    }
  }

  .form-check{
    font-size:.8rem;
  }



</style>



// WEBPACK FOOTER //
// CartPhotoSizeChangePopover.vue?631822d0